// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"ce876496","160":"3e56a5b8","208":"a955ed2d","293":"cde0113f","516":"2129c596","519":"f39bac17","917":"7a703880","946":"d453ff56"}[chunkId] + ".chunk.js";
};